import React, { useEffect, useState } from 'react';
import { Button, ColorPicker, Input, InputNumber, message } from 'antd';
import './detail-index.scss';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../../store';
import { useNavigate, useParams } from 'react-router-dom';
import { createBtd, findBtdByCondition, resetDetail, updateBtd } from '../../../../store/bloodtypedestiny/btdSlice';
import { Color } from 'antd/es/color-picker';

const { TextArea } = Input;
const BtdDetail: React.FC = () => {
  const btdSlice = useSelector((state: RootState) => state.btd);
  const { detail } = btdSlice;
  const { id } = useParams<{ id: string }>();
  const [page, setPage] = useState<number | null>(1);
  const [type, setType] = useState('');
  const [colorName, setColorName] = useState('');
  const [color, setColor] = useState<string>('');
  const [description, setDescription] = useState('');
  const [infoLove, setInfoLove] = useState<number | null>(0);
  const [infoHealthy, setInfoHealthy] = useState<number | null>(0);
  const [infoCareer, setInfoCareer] = useState<number | null>(0);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      dispatch(findBtdByCondition({ id: id }));
    }
    return () => {
      dispatch(resetDetail());
    };
  }, [dispatch, id]);

  useEffect(() => {
    if (detail && id) {
      setPage(detail.page);
      setType(detail.type);
      setColorName(detail.colorName);
      setDescription(detail.description);
      setColor(detail.color);
      setInfoHealthy(detail.lucky.healthy);
      setInfoLove(detail.lucky.love);
      setInfoCareer(detail.lucky.career);
    }
  }, [id, detail]);

  const handleSave = async () => {
    if (!type.trim()) {
      message.error('タイトルを入力してください。');
      return;
    }
    if (!colorName.trim()) {
      message.error('色の名前を入力してください。');
      return;
    }
    if (!color.trim()) {
      message.error('質問を入力してください。');
      return;
    }
    if (description.trim() === '') {
      message.error('説明を入力してください。');
      return;
    }
    const lucky = {
      healthy: infoHealthy || 0,
      love: infoLove || 0,
      career: infoCareer || 0,
    };
    const payload = {
      page,
      type,
      colorName,
      color: color ? color : '#1677ff',
      description,
      lucky,
    };
    if (id) {
      const result = await dispatch(
        updateBtd({
          id,
          ...payload,
        }),
      );
      if (result.meta.requestStatus === 'fulfilled') {
        message.success('更新が成功しました!');
        navigate('/fortune_telling');
      } else {
        message.error('更新に失敗しました。もう一度お試しください。');
      }
    } else {
      const result = await dispatch(createBtd(payload));
      if (result.meta.requestStatus === 'fulfilled') {
        message.success('新規作成が成功しました!');
        navigate('/fortune_telling');
      } else {
        message.error('新規作成に失敗しました。もう一度お試しください!');
      }
    }
  };
  const handleBack = () => {
    window.history.back();
  };
  const handleChangeColor = (color: Color) => {
    const hex = color.toHexString();
    setColor(hex);
  };
  // const handleUploadChange = async ({ fileList: newFileList }) => {
  //   const latestFile = newFileList[newFileList.length - 1];
  //   if (latestFile && latestFile.originFileObj) {
  //     const objectUrl = URL.createObjectURL(latestFile.originFileObj);
  //     setPreviewImage(objectUrl);
  //     setImageUrl(latestFile.originFileObj);
  //   }
  // };

  const resetForm = () => {
    setType('');
    setColor('');
    setDescription('');
    setColorName('');
    setPage(1);
    setInfoCareer(0);
    setInfoHealthy(0);
    setInfoLove(0);
  };

  return (
    <div className="voucher-detail">
      <div className="header">
        <Button className="back-button" onClick={handleBack}>
          ←
        </Button>
        <Button className="save-button" type="primary" onClick={handleSave}>
          保存
        </Button>
      </div>
      <div className="section-title">
        Fortune Telling
        <Button
          type="text"
          icon={
            <img src={`${process.env.PUBLIC_URL}/assets/icons/delete.png`} alt="Delete Logo" className="icon-table" />
          }
          danger
          onClick={() => resetForm()}
        />
      </div>
      <div className="form-container">
        <div className="form-group">
          <label>Page</label>
          <InputNumber min={1} value={page} onChange={(e) => setPage(e)} />
        </div>
        <div className="form-group">
          <label>タイプ</label>
          <Input placeholder="コンテンツを入力" value={type} onChange={(e) => setType(e.target.value)} />
        </div>
        <div className="form-group">
          <label>カラーコードを選択</label>
          <ColorPicker showText value={color} onChange={handleChangeColor} />
        </div>
        <div className="form-group">
          <label>健康運</label>
          <InputNumber min={0} max={5} value={infoHealthy} onChange={(e) => setInfoHealthy(e)} />
        </div>
        <div className="form-group">
          <label>恋愛運</label>
          <InputNumber min={0} max={5} value={infoLove} onChange={(e) => setInfoLove(e)} />
        </div>
        <div className="form-group">
          <label>仕事運</label>
          <InputNumber min={0} max={5} value={infoCareer} onChange={(e) => setInfoCareer(e)} />
        </div>
        <div className="form-group">
          <label>色の名前</label>
          <Input
            placeholder="色の名前を入力してください"
            value={colorName}
            onChange={(e) => setColorName(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label>詳細</label>
          <TextArea
            placeholder="コンテンツを入力"
            rows={4}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default BtdDetail;
